import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { isZoomingSelector, modeSelector } from 'features/map/mapSlice'
import { Coord, DrawItem } from '../types'
import {
    calculateCenter
} from '../utils'
import { addModal } from '../../modals/modalSlice'
import EditMapItemForm from './EditMapItemForm'

export interface DrawImageMapPops {
    image: string
    image_height: number
    image_width: number
    ignoreMouseClicks?: boolean
}
interface ControlOverlayProps {
    callGetMapItems: () => void
    scaledFactor?: number
    items: DrawItem[]
}

interface ControlItem extends DrawItem {
    center: Coord
}

const S = {
    ControlsOverlay: styled.div`
        position: absolute;
        z-index: 2;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        overflow: hidden;
    `,
    Popover: styled.div<{ $center: Coord }>`
        // Arrow
        &:after {
            top: 100%;
            left: 50%;
            border: solid transparent;
            content: '';
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: rgba(136, 183, 213, 0);
            border-top-color: rgba( 255, 255, 255, 0.6);
            border-width: 5px;
            margin-left: -5px;
        }

        border-radius: 4px;
        background-color: rgba( 255, 255, 255, 0.6);
        position: absolute;
        z-index: 1;
        top: ${({ $center }) => $center.y}px;
        left: ${({ $center }) => $center.x}px;
        text-align: center;
        text-overflow: ellipsis;
        font-weight: 500;
        font-size: 14px;
        padding: 2px 4px;
        transform: translate(-50%, -100%);
        cursor: pointer;
        &:hover {
            background-color: white;
            &:after {
                border-top-color: white;
            }
        }
    `,
}

const ItemControl = ({ item, callGetMapItems }: { item: ControlItem, callGetMapItems: () => void }) => {
    const dispatch = useDispatch()
    const renderForm = () => {
        dispatch(
            addModal({
                Component: ({ close }: { close: () => void }) => (
                    <EditMapItemForm close={close} drawItem={item} callGetMapItems={callGetMapItems} />
                ),
                size: 'lg',
                padding: 16,
            })
        )
    }

    return (
        <S.Popover $center={item.center} onClick={renderForm}>
            {item.title}
        </S.Popover>
    )
}

const addCenter = (item: DrawItem, scaledFactor): ControlItem => ({
    ...item,
    center: calculateCenter(item.coords, scaledFactor),
})

const ControlsOverlay = ({ items, callGetMapItems, scaledFactor }: ControlOverlayProps) => {
    const controlItems = items.filter((item) => !item.forMobile).map((item) => addCenter(item, scaledFactor))
    const mode = useSelector(modeSelector)
    const isZooming = useSelector(isZoomingSelector)

    return (
        <S.ControlsOverlay id="image-map-editor">
            {mode !== 'editing' && !isZooming && controlItems.map((item) => (
                <ItemControl key={item.generatedId} item={item} callGetMapItems={callGetMapItems} />
            ))}
        </S.ControlsOverlay>
    )
}

export default ControlsOverlay
